import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../views/common/Constant_Variables/constants';

function* fetchAllFactories() {
  try {
    const { data } = yield call(api.get, {
      route: `factory`,
    });
    const allFactories = data;
    yield put(Actions.setAllFactories({ allFactories }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* fetchAllSimulators() {
  try {
    yield put(Actions.setLoaderAfterUpdate({ afterUpdateLoader: true }));
    const { data } = yield call(api.get, {
      route: `Simulator/GetAllSimulator`,
    });
    const allSimulators = data;
    if (allSimulators) {
      yield put(Actions.setLoaderAfterUpdate({ afterUpdateLoader: false }));
      yield put(Actions.setAllSimulators({ allSimulators }));
    }
  } catch (err) {
    yield put(Actions.setLoaderAfterUpdate({ afterUpdateLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* updateSimulatorState({ simulatorData }) {
  try {
    yield put(Actions.setLoaderAfterUpdate({ afterUpdateLoader: true }));
    yield call(api.put, {
      route: `Simulator`,
      data: simulatorData,
    });
    yield put(Actions.setLoaderAfterUpdate({ afterUpdateLoader: false }));
    yield put(Actions.fetchAllSimulator());
    notification('success', CONSTANT_VARIABLES.SIMULATOR_UPDATED, '');
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllGroups() {
  try {
    const { data } = yield call(api.get, {
      route: `group`,
    });
    const allGroups = data;
    yield put(Actions.setAllGroups({ allGroups }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllDowntimeReasons() {
  try {
    const { data } = yield call(api.get, {
      route: `downtimereason`,
    });
    const allDowntimeReasons = data;
    yield put(Actions.setAllDowntimeReasons({ allDowntimeReasons }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchEquipment({ oeeEquipmentParams }) {
  try {
    const { data } = yield call(api.get, {
      route: `Equipment/` + oeeEquipmentParams.equipId,
    });
    const equipmentData = data;
    yield put(Actions.setEquipment({ equipmentData }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllJobTitles() {
  try {
    const { data } = yield call(api.get, {
      route: `Labour/JobTitles`,
    });
    const allJobTitles = data;
    yield put(Actions.setAllJobTitles({ allJobTitles }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllCrewsByFactoryId({ factoryId }) {
  try {
    const { data } = yield call(api.get, {
      route: `crew/GetAllByFactory/` + factoryId,
    });
    const allFetchCrews = data;
    yield put(Actions.setFetchAllCrews({ allFetchCrews }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err);
  }
}

function* fetchAllFactoryDepartments({ factoryId }) {
  try {
    const { data } = yield call(api.get, {
      route: `department/factory/` + factoryId,
    });
    const factoryDepartments = data;
    yield put(Actions.setAllFactoryDepartments({ factoryDepartments }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllDepartments() {
  try {
    const { data } = yield call(api.get, {
      route: 'department',
    });
    const departmentsData = data;
    yield put(Actions.setAllDepartments({ departmentsData }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* updateDowntimeReason({ downtimeReasonObj, callback }) {
  try {
    if (downtimeReasonObj != null || downtimeReasonObj.downtimeReasonId >= 1 || downtimeReasonObj.equipmentId >= 1) {
      const { data } = yield call(api.put, {
        route: `downtime/updateReason`,
        data: downtimeReasonObj,
      });
      yield put(Actions.setLoaderAfterUpdate({ afterUpdateLoader: false }));
      const messageData = data ? data.toJS() : [];
      if (messageData.messages !== null && messageData.messages.length > 0) {
        notification('info', messageData.messages[0], '');
      } else {
        if (callback) callback();
        notification('success', CONSTANT_VARIABLES.DOWNTIME_UPDATED, '');
      }
    } else {
      notification('error', 'Something went wrong.', '');
    }
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* closeEquipmentDowntime({ equipmentId }) {
  try {
    yield call(api.post, {
      route: `downtime/closeopendowntimes/` + equipmentId,
    });
    yield put(Actions.setLoaderAfterUpdate({ afterUpdateLoader: false }));
    notification('success', CONSTANT_VARIABLES.DOWNTIME_CLOSED, '');
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
// delete future downtime
function* deleteEquipmentDowntime({ downtimeId }) {
  try {
    yield call(api.delete, {
      route: `downtime/${downtimeId}`,
    });
    yield put(Actions.setLoaderAfterUpdate({ afterUpdateLoader: false }));
    notification('success', CONSTANT_VARIABLES.DOWNTIME_DELETED, '');
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

// reset db saga
function* resetDBData({ resetObj }) {
  try {
    let { env, user } = resetObj;
    yield put(Actions.setLoaderAfterUpdate({ afterUpdateLoader: true }));
    yield call(api.post, { route: `GlobalDashboard/reset/db/${env}/${user}` });
    yield put(Actions.setLoaderAfterUpdate({ afterUpdateLoader: false }));
    window.location.reload(true);
  } catch (error) {
    console.warn(error); // Handle exception
  }
}

function* fetchOeeEquipmentByID({ oeeEquipmentId }) {
  try {
    const { data } = yield call(api.get, {
      route: `oee/` + oeeEquipmentId.equipId,
    });
    const equipDataById = data;
    yield put(Actions.setOeeEquipmentByID({ equipDataById }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL_FACTORIES, fetchAllFactories),
    takeLatest(ActionTypes.FETCH_ALL_SIMULATOR, fetchAllSimulators),
    takeLatest(ActionTypes.UPDATE_SIMULATOR_STATE, updateSimulatorState),
    takeLatest(ActionTypes.RESET_DB, resetDBData),
    takeLatest(ActionTypes.FETCH_ALL_GROUPS, fetchAllGroups),
    takeLatest(ActionTypes.FETCH_ALL_DOWNTIME_REASONS, fetchAllDowntimeReasons),
    takeLatest(ActionTypes.FETCH_EQUIPMENT, fetchEquipment),
    takeLatest(ActionTypes.FETCH_ALL_JOBTITLES, fetchAllJobTitles),
    takeLatest(ActionTypes.FETCH_ALL_FACTORY_DEPARTMENTS, fetchAllFactoryDepartments),
    takeLatest(ActionTypes.FETCH_ALL_DEPARTMENTS, fetchAllDepartments),
    takeLatest(ActionTypes.UPDATE_DOWNTIME_REASON, updateDowntimeReason),
    takeLatest(ActionTypes.CLOSE_EQUIPMENT_DOWNTIME, closeEquipmentDowntime),
    takeLatest(ActionTypes.DELETE_EQUIPMENT_DOWNTIME, deleteEquipmentDowntime),
    takeLatest(ActionTypes.FETCH_OEE_EQUIPMENT_BY_ID, fetchOeeEquipmentByID),
    takeLatest(ActionTypes.FETCH_ALL_CREWS_BY_FACTORY, fetchAllCrewsByFactoryId),
  ]);
}
